module.exports = __webpack_public_path__ + "img/login-back.ccbf2c35.png";